module.exports = "<app-home></app-home>"


//////////////////
// WEBPACK FOOTER
// ./src/app/industry/industry.component.html
// module id = ./src/app/industry/industry.component.html
// module chunks = main